
export class Cuenta
{
    id: string;
    nombre: string;
    descripcion: string;
    uid: string;
    category: string;
    currency: any;

    /**
     * Constructor
     *
     * @param Account
     */
    constructor(account)
    {
        {
            this.id = account.id || 0;
            this.nombre = account.nombre || '';
            this.descripcion = account.descripcion || '';
            this.uid = account.uid || '';
            this.category = account.category     || '';
            this.currency = account.currency     || '';
        }
    }
}
